import { Outlet } from 'react-router-dom';
import { EditSearchForm } from '../components/EditSearchForm';

export const CountyLayout: React.FC = () => (
  <>
    <EditSearchForm />
    <Outlet />
  </>
);
